import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Send } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { toast } from 'sonner';

import axios from 'axios';

const BASE_URL = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/+$/, '');
const API_URL = `${BASE_URL}/api`;

export const Newsletter = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const trimmed = email.trim();
    if (!trimmed) return;

    setLoading(true);
    try {
      await axios.post(`${API_URL}/newsletter/subscribe`, { email: trimmed });
      toast.success(t('footer.subscribeSuccess') || 'Subscribed successfully!');
      setEmail('');
    } catch (error) {
      const msg = error?.response?.data?.detail || error?.response?.data?.message || 'Subscription failed';
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-gradient-hero rounded-2xl p-8 md:p-12">
      <div className="max-w-2xl mx-auto text-center">
        <h3 className="font-serif text-3xl font-bold text-foreground mb-3">
          {t('footer.stayUpdated')}
        </h3>
        <p className="text-muted-foreground mb-6">
          {t('footer.newsletterText')}
        </p>
        <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3">
          <Input
            type="email"
            placeholder={t('footer.enterEmail')}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="flex-1"
          />
          <Button type="submit" size="lg" disabled={loading}>
            <Send className="w-4 h-4 mr-2" />
            {t('footer.subscribe')}
          </Button>
        </form>
        <p className="text-xs text-muted-foreground mt-4">
          {t('footer.privacyRespect')}
        </p>
      </div>
    </div>
  );
};